"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// src/data/Products_15.ts
const product_types_1 = require("../types/product.types");
const products = [
    // 1245. Campus Espai Bulevard 40a Promoció (2026/2027)
    {
        id: 1245,
        tax: 0.0,
        sku: "iopos.course.f2f.campus-espai-bulevard-40a-promocio",
        title: "Campus Espai Bulevard 40a Promoció (2026/2027)",
        name: "Campus Espai Bulevard 40a Promoció (2026/2027)",
        description: "Prepara't amb la formació pionera que ha aconseguit resultats extraordinaris: 8 sessions pràctiques, campus virtual i docents de referència per arribar 100x100 preparat a l'ISPC.",
        enabled: true,
        stock: false,
        stock_message: "Sense places",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 299.99,
        images: ["/1245/image_h"],
        banner: ["/1245/image1"],
        link: "/tienda/cursos/campus-espai-bulevard-40a-promocio-2026-2027/",
        more_info: true,
        can_be_sent: false,
        items: 1,
        created_at: "2026-06-30 00:00:01",
        start_at: "2026-06-30 00:00:01",
        updated_at: "2026-06-30 00:00:01",
        productImage: {
            landscape: "/1245/image_h",
            portrait: "/1245/image_v",
        },
        hero: {
            firstTitle: "Campus Espai Bulevard 40a Promoció",
            secondTitle: "Edició 2026/2027",
            thirdTitle: "Prepara't **avui** per afrontar amb **confiança** el **repte més important** abans de començar la teva etapa a l'**ISPC**.",
            landscape: "/1245/image_h",
            portrait: "/1245/image_v",
        },
        childs: [1246, 1247, 1248],
        notify_emails: ["tonicalvo@iopos.academy"],
    },
    // 1246. Campus Espai Bulevard 40a Promoció (2026/2027) - Grup 1: Dissabtes de 16 a 19 h
    {
        id: 1246,
        tax: 0.0,
        sku: "iopos.course.f2f.campus-espai-bulevard-40a-promocio-g1",
        title: "Campus Espai Bulevard 40a Promoció (2026/2027) - Grup 1: Dissabtes de 16 a 19 h",
        name: "Campus Espai Bulevard 40a Promoció (2026/2027) - Grup 1: Dissabtes de 16 a 19 h",
        short: "Grup 1: Dissabtes de 16 a 19 h - Campus Espai Bulevard 40a Promoció (2026/2027)",
        description: "Prepara't avui per afrontar amb confiança el repte més important abans de començar la teva etapa a l'ISPC.",
        enabled: true,
        stock: false,
        stock_message: "Aviat disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 299.99,
        images: ["/1245/image_h"],
        banner: ["/1245/image1"],
        link: "/tienda/cursos/campus-espai-bulevard-40a-promocio-2026-2027/",
        more_info: false,
        can_be_sent: false,
        items: 1,
        created_at: "2026-06-30 00:00:01",
        start_at: "2026-06-30 00:00:01",
        updated_at: "2026-06-30 00:00:01",
        parent: 1245,
        productImage: {
            landscape: "/1245/image_h",
            portrait: "/1245/image_v",
        },
        hero: {
            firstTitle: "Campus Espai Bulevard 40a Promoció",
            secondTitle: "Edició 2026/2027",
            thirdTitle: "Prepara't **avui** per afrontar amb **confiança** el **repte més important** abans de començar la teva etapa a l'**ISPC**.",
            landscape: "/1245/image_h",
            portrait: "/1245/image_v",
        },
        evolmind: {
            course_id: 1309,
            group_id: [3256],
        },
        notify_emails: ["tonicalvo@iopos.academy"],
    },
    // 1247. Campus Espai Bulevard 40a Promoció (2026/2027) - Grup 2: Dissabtes de 19 a 22 h
    {
        id: 1247,
        tax: 0.0,
        sku: "iopos.course.f2f.campus-espai-bulevard-40a-promocio-g2",
        title: "Campus Espai Bulevard 40a Promoció (2026/2027) - Grup 2: Dissabtes de 19 a 22 h",
        name: "Campus Espai Bulevard 40a Promoció (2026/2027) - Grup 2: Dissabtes de 19 a 22 h",
        short: "Grup 2: Dissabtes de 19 a 22 h - Campus Espai Bulevard 40a Promoció (2026/2027)",
        description: "Prepara't avui per afrontar amb confiança el repte més important abans de començar la teva etapa a l'ISPC.",
        enabled: true,
        stock: false,
        stock_message: "Sense places",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 299.99,
        images: ["/1245/image_h"],
        banner: ["/1245/image1"],
        link: "/tienda/cursos/campus-espai-bulevard-40a-promocio-2026-2027/",
        more_info: false,
        can_be_sent: false,
        items: 1,
        created_at: "2026-06-30 00:00:01",
        start_at: "2026-06-30 00:00:01",
        updated_at: "2026-06-30 00:00:01",
        parent: 1245,
        productImage: {
            landscape: "/1245/image_h",
            portrait: "/1245/image_v",
        },
        hero: {
            firstTitle: "Campus Espai Bulevard 40a Promoció",
            secondTitle: "Edició 2026/2027",
            thirdTitle: "Prepara't **avui** per afrontar amb **confiança** el **repte més important** abans de començar la teva etapa a l'**ISPC**.",
            landscape: "/1245/image_h",
            portrait: "/1245/image_v",
        },
        evolmind: {
            course_id: 1309,
            group_id: [3259],
        },
        notify_emails: ["tonicalvo@iopos.academy"],
    },
    // 1248. Campus Espai Bulevard 40a Promoció (2026/2027) - Grup 3: Diumenges de 16 a 19 h
    {
        id: 1248,
        tax: 0.0,
        sku: "iopos.course.f2f.campus-espai-bulevard-40a-promocio-g3",
        title: "Campus Espai Bulevard 40a Promoció (2026/2027) - Grup 3: Diumenges de 16 a 19 h",
        name: "Campus Espai Bulevard 40a Promoció (2026/2027) - Grup 3: Diumenges de 16 a 19 h",
        short: "Grup 3: Diumenges de 16 a 19 h - Campus Espai Bulevard 40a Promoció (2026/2027)",
        description: "Prepara't avui per afrontar amb confiança el repte més important abans de començar la teva etapa a l'ISPC.",
        enabled: true,
        stock: false,
        stock_message: "No disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Bulevard],
        price: 299.99,
        images: ["/1245/image_h"],
        banner: ["/1245/image1"],
        link: "/tienda/cursos/campus-espai-bulevard-40a-promocio-2026-2027/",
        more_info: false,
        can_be_sent: false,
        items: 1,
        created_at: "2026-06-30 00:00:01",
        start_at: "2026-06-30 00:00:01",
        updated_at: "2026-06-30 00:00:01",
        parent: 1245,
        productImage: {
            landscape: "/1245/image_h",
            portrait: "/1245/image_v",
        },
        hero: {
            firstTitle: "Campus Espai Bulevard 40a Promoció",
            secondTitle: "Edició 2026/2027",
            thirdTitle: "Prepara't **avui** per afrontar amb **confiança** el **repte més important** abans de començar la teva etapa a l'**ISPC**.",
            landscape: "/1245/image_h",
            portrait: "/1245/image_v",
        },
        evolmind: {
            course_id: 1309,
            group_id: [3262],
        },
        notify_emails: ["tonicalvo@iopos.academy"],
    },
    // 1249. Curs Presencial Mossos d'Esquadra (2026) - Grup 5: Dissabtes Matí
    {
        id: 1249,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-presencial-mossos-2026-30-hores-g5",
        title: "Curs Presencial Mossos d'Esquadra 2026 (30 hores) - Grup 5 - Dissabtes Matí",
        name: "Curs Presencial Mossos d'Esquadra 2026 (30 hores) - Grup 5 - Dissabtes Matí",
        short: "Curs Presencial Mossos - Grup 5 (Dissabtes Matí 08:30 - 14:30)",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "Prepara Mossos amb estructura, criteri i confiança: 30 hores presencials que marquen la diferència el dia de l’examen",
        enabled: true,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 299.99,
        // offer: 299.99,
        // offer_message: "Oferta de llançament!",
        // offer_text: "Oferta de llançament!",
        shipment: 0.0,
        images: ["/1202/image_h"],
        link: "/tienda/cursos/curs-presencial-mossos-desquadra-2026-30-hores/",
        created_at: "2026-03-30 00:00:10",
        start_at: "2026-03-30 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        productImage: {
            landscape: "/1202/image_h",
            portrait: "/1202/image_v",
        },
        hero: {
            firstTitle: "Curs Presencial Mossos d'Esquadra",
            secondTitle: "Convocatòria 2026",
            thirdTitle: "**Prepara Mossos amb estructura, criteri i confiança:** 30 hores presencials que marquen la diferència el dia de l'examen.",
            landscape: "/1202/hero_h",
            portrait: "/1202/hero_v",
        },
        parent: 1202,
        evolmind: {
            course_id: 1267,
            group_id: [3265],
        },
    },
    // 1250. Curs Onine Campus Pràctica Bulevard - 40a Promoció (2026/2027)
    {
        id: 1250,
        tax: 0.21,
        category: [product_types_1.Category.Bulevard, product_types_1.Category.Online],
        sku: "iopos.course.online.campus-practic-bulevard-40a-promocio-2026-2027",
        title: "Campus Pràctic del Bulevard - 40a Promoció (2026/2027)",
        name: "Campus Pràctic del Bulevard - 40a Promoció (2026/2027)",
        description: "Arriba a l'ISPC amb la confiança de qui ja sap què es trobarà.",
        enabled: true,
        stock: true,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 119.99,
        shipment: 0.0,
        images: ["/1250/image_h"],
        banner: ["/1250/image_h"],
        link: "/tienda/cursos/campus-practic-bulevard-40a-promocio/",
        created_at: "2026-07-13 00:00:01",
        start_at: "2026-07-13 00:00:01",
        more_info: true,
        release: false,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        evolmind: { course_id: 1309, group_id: [3268] },
        productImage: {
            landscape: "/1250/image_h",
            portrait: "/1250/image_v",
        },
        hero: {
            firstTitle: "Curs Online d'Orientació a l'ISPC 40ª Promoció",
            secondTitle: "Convocatòria 2026/27",
            thirdTitle: "**Avançat a la 40a promoció amb el curs més complet i actualitzat!** Accedeix a tots els continguts necessaris des del primer moment i prepara't amb el millor material disponible.",
            landscape: "/1250/hero_h",
            portrait: "/1250/hero_v",
        },
    },
    // 1251. Curs Presencial Mossos d'Esquadra (2026) - Grup 6: Diumenges Matí
    {
        id: 1251,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-presencial-mossos-2026-30-hores-g6",
        title: "Curs Presencial Mossos d'Esquadra 2026 (30 hores) - Grup 6 - Diumenges Matí",
        name: "Curs Presencial Mossos d'Esquadra 2026 (30 hores) - Grup 6 - Diumenges Matí",
        short: "Curs Presencial Mossos - Grup 6 (Diumenges Matí)",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "Prepara Mossos amb estructura, criteri i confiança: 30 hores presencials que marquen la diferència el dia de l’examen",
        enabled: true,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 299.99,
        // offer: 299.99,
        // offer_message: "Oferta de llançament!",
        // offer_text: "Oferta de llançament!",
        shipment: 0.0,
        images: ["/1202/image_h"],
        link: "/tienda/cursos/curs-presencial-mossos-desquadra-2026-30-hores/",
        created_at: "2026-03-30 00:00:10",
        start_at: "2026-03-30 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        productImage: {
            landscape: "/1202/image_h",
            portrait: "/1202/image_v",
        },
        hero: {
            firstTitle: "Curs Presencial Mossos d'Esquadra",
            secondTitle: "Convocatòria 2026",
            thirdTitle: "**Prepara Mossos amb estructura, criteri i confiança:** 30 hores presencials que marquen la diferència el dia de l'examen.",
            landscape: "/1202/hero_h",
            portrait: "/1202/hero_v",
        },
        parent: 1202,
        evolmind: {
            course_id: 1267,
            group_id: [3271],
        },
    },
    // 1252. Curs Presencial Psicotècnics Aptitudinals (8 hores - 13 setembre 2026 09-18h)
    {
        id: 1252,
        type: product_types_1.Type.Course,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.classroom.curs-intensiu-presencial-psicos-aptitudinals-13-setembre-2026",
        title: "Curs Presencial Psicotècnics Apt. Mossos 2026 [8h] (13/09 · 09-18h)",
        name: "Curs Presencial de Psicotècnics Apt. Mossos 2026 [8h] (13/09 · 09-18h)",
        short: "5.) Presencial de Psicos. Mossos 2026 (13/09 · 09-18h)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Domina els psicotècnics en només un dia: entrenament intensiu de 8h amb tècniques clares, exercicis oficials i estratègies guanyadores per aprovar els Mossos 2025.",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 99.99,
        shipment: 0.0,
        images: ["/939/image1_h"],
        banner: ["/939/image1_h"],
        link: "/tienda/cursos/curs-presencial-psicotecnics-aptitudinals-25-i-26-juny-2026-tarda/",
        created_at: "2026-06-16 00:00:01",
        start_at: "2026-06-16 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 939,
        limit: 30,
    },
    // 1253. MasterClass Online Mossos d'Esquadra - Àmbit A (16/09/2026)
    {
        id: 1253,
        type: product_types_1.Type.Course,
        tax: 0.21,
        sku: "iopos.course.online.masterclass-online-mossos-esquadra-ambit-a-16-setembre-2026",
        title: "MasterClass Online Mossos d'Esquadra - Àmbit A (16/09/2026)",
        name: "MasterClass Online Mossos d'Esquadra - Àmbit A (16/09/2026)",
        category: [product_types_1.Category.Mossos, product_types_1.Category.Online],
        description: "Consolida l'Àmbit A amb una única sessió intensiva i arriba a l'examen amb més confiança.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        price: 24.99,
        offer: 49.99,
        offer_message: "Sessió enregistrada.",
        offer_text: "Sessió enregistrada.",
        shipment: 0.0,
        images: ["/1253/image_h"],
        banner: ["/1253/image_h"],
        link: "/tienda/cursos/masterclass-online-mossos-esquadra-ambit-a-16-setembre-2026/",
        created_at: "2026-07-17 00:00:01",
        start_at: "2026-07-17 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        productImage: {
            landscape: "/1253/image_h",
            portrait: "/1253/image_v",
        },
        hero: {
            firstTitle: "MasterClass Online Mossos d'Esquadra",
            secondTitle: "Àmbit A",
            thirdTitle: "Consolida l'Àmbit A amb una única sessió intensiva i arriba a l'examen amb més confiança.",
            landscape: "/1253/hero_h",
            portrait: "/1253/hero_v",
        },
        evolmind: {
            course_id: 1318,
            group_id: [3274],
        },
    },
    // 1254. MasterClass Online Mossos d'Esquadra - Àmbit B (16/09/2026)
    {
        id: 1254,
        type: product_types_1.Type.Course,
        tax: 0.21,
        sku: "iopos.course.online.masterclass-online-mossos-esquadra-ambit-b-23-setembre-2026",
        title: "MasterClass Online Mossos d'Esquadra - Àmbit B (23/09/2026)",
        name: "MasterClass Online Mossos d'Esquadra - Àmbit B (23/09/2026)",
        category: [product_types_1.Category.Mossos, product_types_1.Category.Online],
        description: "Converteix un dels àmbits més densos del temari en un dels teus punts forts.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        price: 24.99,
        offer: 49.99,
        offer_message: "Sessió enregistrada.",
        offer_text: "Sessió enregistrada.",
        shipment: 0.0,
        images: ["/1254/image_h"],
        banner: ["/1254/image_h"],
        link: "/tienda/cursos/masterclass-online-mossos-esquadra-ambit-b-23-setembre-2026/",
        created_at: "2026-07-17 00:00:01",
        start_at: "2026-07-17 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        productImage: {
            landscape: "/1254/image_h",
            portrait: "/1254/image_v",
        },
        hero: {
            firstTitle: "MasterClass Online Mossos d'Esquadra",
            secondTitle: "Àmbit B",
            thirdTitle: "Converteix un dels àmbits més densos del temari en un dels teus punts forts.",
            landscape: "/1254/hero_v",
            portrait: "/1254/hero_v",
        },
        evolmind: {
            course_id: 1315,
            group_id: [3277],
        },
    },
    // 1255. MasterClass Online Mossos d'Esquadra - Àmbit C (30/09/2026)
    {
        id: 1255,
        type: product_types_1.Type.Course,
        tax: 0.21,
        sku: "iopos.course.online.masterclass-online-mossos-esquadra-ambit-c-30-setembre-2026",
        title: "MasterClass Online Mossos d'Esquadra - Àmbit C (30/09/2026)",
        name: "MasterClass Online Mossos d'Esquadra - Àmbit C (30/09/2026)",
        category: [product_types_1.Category.Mossos, product_types_1.Category.Online],
        description: "Comprèn els procediments, les competències i l'organització policial en una única sessió intensiva orientada a examen.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        price: 24.99,
        offer: 49.99,
        offer_message: "Sessió enregistrada.",
        offer_text: "Sessió enregistrada.",
        shipment: 0.0,
        images: ["/1255/image_h"],
        banner: ["/1255/image_h"],
        link: "/tienda/cursos/masterclass-online-mossos-esquadra-ambit-c-30-setembre-2026/",
        created_at: "2026-07-17 00:00:01",
        start_at: "2026-07-17 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        productImage: {
            landscape: "/1255/image_h",
            portrait: "/1255/image_v",
        },
        hero: {
            firstTitle: "MasterClass Online Mossos d'Esquadra",
            secondTitle: "Àmbit C",
            thirdTitle: "Comprèn els procediments, les competències i l'organització policial en una única sessió intensiva orientada a examen.",
            landscape: "/1255/hero_h",
            portrait: "/1255/hero_v",
        },
        evolmind: {
            course_id: 1312,
            group_id: [3280],
        },
    },
    // 1256. Curs Presencial LastWeek of Mossos (2026) - 10 hores
    {
        id: 1256,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-presencial-lastweek-of-mossos-2026-10-hores",
        title: "Curs Presencial LastWeek of Mossos (2026) - 10 hores",
        name: "Curs Presencial LastWeek of Mossos (2026) - 10 hores",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "10 hores que poden marcar la diferència entre aprovar i quedar-te a les portes.",
        enabled: true,
        stock: false,
        stock_message: "No disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 119.99,
        shipment: 0.0,
        images: ["/1256/image_h"],
        link: "/tienda/cursos/curs-presencial-lastweek-of-mossos-2026-10-hores/",
        created_at: "2026-07-17 00:00:10",
        start_at: "2026-07-17 00:00:10",
        more_info: true,
        can_be_sent: false,
        items: 1,
        productImage: {
            landscape: "/1256/image_h",
            portrait: "/1256/image_v",
        },
        hero: {
            firstTitle: "LastWeek of Mossos (2026)",
            secondTitle: "Curs Presencial de 10 hores",
            thirdTitle: "El repàs definitiu per arribar a l'examen amb la màxima confiança.",
            landscape: "/1256/hero_h",
            portrait: "/1256/hero_v",
        },
        childs: [1257, 1258],
    },
    // 1257. Curs Presencial LastWeek of Mossos (2026) - 10 hores - Grup 1: Dissabte 03/10/2026
    {
        id: 1257,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-presencial-lastweek-of-mossos-2026-10-hores-g1-3-10-2026",
        title: "Curs Presencial LastWeek of Mossos (2026) - 10 h - Grup 1: Dissabte 03/10/2026",
        name: "Curs Presencial LastWeek of Mossos (2026) - 10 h - Grup 1: Dissabte 03/10/2026",
        short: "LastWeek of Mossos (2026) - Grup 1: Dissabte 03/10/2026",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "10 hores que poden marcar la diferència entre aprovar i quedar-te a les portes.",
        enabled: true,
        stock: false,
        stock_message: "Aviat disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 119.99,
        shipment: 0.0,
        images: ["/1256/image_h"],
        link: "/tienda/cursos/curs-presencial-lastweek-of-mossos-2026-10-hores/",
        created_at: "2026-03-30 00:00:10",
        start_at: "2026-03-30 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        productImage: {
            landscape: "/1256/image_h",
            portrait: "/1256/image_v",
        },
        hero: {
            firstTitle: "LastWeek of Mossos (2026)",
            secondTitle: "Curs Presencial de 10 hores",
            thirdTitle: "El repàs definitiu per arribar a l'examen amb la màxima confiança.",
            landscape: "/1256/hero_h",
            portrait: "/1256/hero_v",
        },
        parent: 1256,
        evolmind: {
            course_id: 1267,
            group_id: [3283],
        },
    },
    // 1258. Curs Presencial LastWeek of Mossos (2026) - 10 hores - Grup 2: Diumenge 04/10/2026
    {
        id: 1258,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-presencial-lastweek-of-mossos-2026-10-hores-g2-4-10-2026",
        title: "Curs Presencial LastWeek of Mossos (2026) - 10 h - Grup 2: Diumenge 04/10/2026",
        name: "Curs Presencial LastWeek of Mossos (2026) - 10 h - Grup 2: Diumenge 04/10/2026",
        short: "LastWeek of Mossos (2026) - Grup 2: Diumenge 04/10/2026",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "10 hores que poden marcar la diferència entre aprovar i quedar-te a les portes.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 119.99,
        shipment: 0.0,
        images: ["/1256/image_h"],
        link: "/tienda/cursos/curs-presencial-lastweek-of-mossos-2026-10-hores/",
        created_at: "2026-03-30 00:00:10",
        start_at: "2026-03-30 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        productImage: {
            landscape: "/1256/image_h",
            portrait: "/1256/image_v",
        },
        hero: {
            firstTitle: "LastWeek of Mossos (2026)",
            secondTitle: "Curs Presencial de 10 hores",
            thirdTitle: "El repàs definitiu per arribar a l'examen amb la màxima confiança.",
            landscape: "/1256/hero_h",
            portrait: "/1256/hero_v",
        },
        parent: 1256,
        evolmind: {
            course_id: 1267,
            group_id: [3286],
        },
    },
    // 1259. Curs Presencial Psicotècnics Aptitudinals (8 hores - Grup 6: Dissabte 5 de setembre 2026 09-18h)
    {
        id: 1259,
        type: product_types_1.Type.Course,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.classroom.curs-intensiu-presencial-psicos-aptitudinals-5-setembre-2026",
        title: "Curs Presencial Psicotècnics Apt. Mossos 2026 [8h] (05/09 · 09-18h)",
        name: "Curs Presencial de Psicotècnics Apt. Mossos 2026 [8h] (05/09 · 09-18h)",
        short: "6.) Presencial de Psicos. Mossos 2026 (05/09 · 09-18h)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Domina els psicotècnics en només un dia: entrenament intensiu de 8h amb tècniques clares, exercicis oficials i estratègies guanyadores per aprovar els Mossos 2025.",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 99.99,
        shipment: 0.0,
        images: ["/939/image1_h"],
        banner: ["/939/image1_h"],
        link: "/tienda/cursos/curs-presencial-psicotecnics-aptitudinals-25-i-26-juny-2026-tarda/",
        created_at: "2026-06-16 00:00:01",
        start_at: "2026-06-16 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 939,
        limit: 30,
    },
    // 1260. Tutorització Presencial Mossos d'Esquadra 2026 (Grup 2)
    {
        id: 1260,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.tutoritzacio-presencial-mossos-2026-g2",
        title: "Tutorització Presencial Mossos d'Esquadra 2026 (Grup 2 - 20/09/2026 - 13:30 a 18:30h)",
        name: "Tutorització Presencial Mossos d'Esquadra 2026 (Grup 2 - 20/09/2026 - 13:30 a 18:30h)",
        short: "Grup 2) Tutorització Presencial Mossos 2026 (20/09/2026 - 13:30 a 18:30h)",
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        description: "Descobreix el teu nivell real abans de l’examen i prepara’t amb més garanties.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 69.99,
        shipment: 0.0,
        images: ["/1242/image_h"],
        link: "/tienda/cursos/tutoritzacio-presencial-mossos-2026/",
        created_at: "2026-06-22 00:00:10",
        start_at: "2026-06-22 00:00:10",
        more_info: false,
        can_be_sent: false,
        items: 1,
        productImage: {
            landscape: "/1242/image_h",
            portrait: "/1242/image_v",
        },
        hero: {
            firstTitle: "Tutorització Presencial Mossos d'Esquadra",
            secondTitle: "Any 2026",
            thirdTitle: "Descobreix el teu **nivell real** abans de l’examen i prepara’t amb **més garanties**.",
            landscape: "/1242/hero_h",
            portrait: "/1242/hero_v",
        },
        parent: 1242,
    },
    // 1261. Preparació Intensiva d'Entrevista Grupal Guàrdia Urbana de Badalona - Especial Role Play (22/08/2026)
    {
        id: 1261,
        type: product_types_1.Type.Course,
        tax: 0.21,
        sku: "iopos.course.online.prep-int-entr-grupal-guardia-urbana-badalona-roleplay-22-08-2026-zoom",
        title: "Preparació Intensiva d'Entrevista Grupal Gùardia Urbana de Badalona (Especial Role Play 22/08/2026 Zoom)",
        name: "Preparació Intensiva d'Entrevista Grupal Gùardia Urbana de Badalona (Especial Role Play 22/08/2026 Zoom)",
        category: [product_types_1.Category.PL, product_types_1.Category.FaceToFace],
        description: "Prepara’t per afrontar amb seguretat l’entrevista grupal de la Guàrdia Urbana de Badalona. Sessió intensiva especial Role Play per practicar situacions reals i marcar la diferència el dia de la prova.",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 19.99,
        offer: 39.99,
        offer_message: "Accedeix a a la formació gravada a un preu reduït!",
        offer_text: "Accedeix a a la formació gravada a un preu reduït!",
        shipment: 0.0,
        images: ["/0/image1"],
        banner: ["/0/image1"],
        link: "/tienda/cursos/preparacio-intensiva-dentrevista-grupal-guardia-urbana-badalona-roleplay-22-08-2026-zoom/",
        created_at: "2026-06-16 00:00:01",
        start_at: "2026-06-16 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        limit: 30,
        evolmind: {
            course_id: 1321,
            group_id: [3289],
        },
    },
    // 1262. Curs Presencial Psicotècnics Apt. Mossos 2026 [8h] (19/09 · 09-18h)
    {
        id: 1262,
        type: product_types_1.Type.Course,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.classroom.curs-intensiu-presencial-psicos-aptitudinals-19-setembre-2026",
        title: "Curs Presencial Psicotècnics Apt. Mossos 2026 [8h] (19/09 · 09-18h)",
        name: "Curs Presencial de Psicotècnics Apt. Mossos 2026 [8h] (19/09 · 09-18h)",
        short: "7.) Presencial de Psicos. Mossos 2026 (19/09 · 09-18h)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Domina els psicotècnics en només un dia: entrenament intensiu de 8h amb tècniques clares, exercicis oficials i estratègies guanyadores per aprovar els Mossos 2025.",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 99.99,
        shipment: 0.0,
        images: ["/939/image1_h"],
        banner: ["/939/image1_h"],
        link: "/tienda/cursos/curs-presencial-psicotecnics-aptitudinals-25-i-26-juny-2026-tarda/",
        created_at: "2026-06-16 00:00:01",
        start_at: "2026-06-16 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 939,
        limit: 30,
    },
    // 1263. Curs Online de Psicotècnics Aptitudinals (12 hores en directe - 2026)
    {
        id: 1263,
        type: product_types_1.Type.Course,
        tax: 0.21,
        sku: "iopos.course.online.curs-online-psicotecnics-aptitudinals-12h-2026",
        title: "Curs Online de Psicotècnics Aptitudinals (12 hores en directe - 2026 - Setembre i Octubre)",
        name: "Curs Online de Psicotècnics Aptitudinals (12 hores en directe - 2026 - Setembre i Octubre)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.Online],
        description: "Domina la tècnica, guanya velocitat i arriba a l’examen amb una estratègia clara.",
        enabled: true,
        stock: true,
        stock_message: "No disponible",
        price: 99.99,
        // offer: 99.99,
        // offer_message: "Oferta les primeres 25 places!",
        // offer_text: "Oferta les primeres 25 places!",
        shipment: 0.0,
        images: ["/1263/image_h"],
        banner: ["/1263/image_h"],
        productImage: {
            landscape: "/1263/image_h",
            portrait: "/1263/image_v",
        },
        link: "/tienda/cursos/curs-online-expres-de-psicotecnics-aptitudinals-2026/",
        created_at: "2026-08-21 00:00:01",
        start_at: "2026-08-21 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        hero: {
            firstTitle: "Curs Online Psicotècnics Aptitudinals",
            secondTitle: "12 hores en directe - Setembre i Octubre 2026",
            thirdTitle: "Domina la tècnica, guanya velocitat i arriba a **l’examen** amb una **estratègia clara**.",
            landscape: "/1263/hero_h",
            portrait: "/1263/hero_v",
        },
        evolmind: {
            course_id: 1324,
            group_id: [3298],
        },
    },
    // 1265. Curs Homologat Semipresencial Llei Orgànica 4/2015 (2026) (26 setembre - matí 08:30 a 12:30)
    {
        id: 1265,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        tax: 0.0,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.ISPC,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.HOMOLOGADOS,
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
        ],
        sku: "iopos.course.f2f.curs-homologat-semipresencial-llei-organica-4-2015-4-hores-2026-26-setembre-grup-mati",
        title: "Curs Homologat Semipresencial Llei Orgànica 4/2015 (2026) (26 setembre - matí 08:30 a 12:30)",
        name: "Curs Homologat Semipresencial Llei Orgànica 4/2015 (2026) (26 setembre - matí 08:30 a 12:30)",
        short: "5.) Curs Semipresencial Homologat Llei Orgànitca 4/2015 (26 setembre - matí 08:30 a 12:30)",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        shipment: 0.0,
        images: ["/1187/image1_h"],
        banner: ["/1187/image1_h"],
        link: "/tienda/cursos/curs-semipresencial-homologat-llei-organica-4-2015-2026/",
        created_at: "2026-03-17 00:00:01",
        start_at: "2026-03-17 00:00:01",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        parent: 1187,
        evolmind: {
            course_id: 1114,
            group_id: [3301],
        },
        productImage: {
            portrait: "/1187/image1_v.jpg",
            landscape: "/1187/image1_h.jpg",
        },
        default_in_parent: true,
        homologated: [
            {
                code: "RP20250070869",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
    },
];
exports.default = products;
